export const CHATBOT_STATUSES = {
  MISSING_FEELING: 'Missing feeling',
  EXTRACTING_INSIGHTS: 'Extracting insights',
  NOT_ALL_PAGES_SUBMITTED: 'Not all pages submitted',
  WAITING_FOR_INITIAL_MESSAGE: 'Waiting for initial message',
  LOADING: 'Loading',
  READY: 'Ready',
  ERROR: 'Error'
};

export const CHATBOT_MESSAGES = {
  [CHATBOT_STATUSES.MISSING_FEELING]:
    'Can you go to assignment detail and select emotion before we proceed?',
  [CHATBOT_STATUSES.NOT_ALL_PAGES_SUBMITTED]:
    'It looks like not all pages have been submitted. Please check and submit any missing pages.',
  [CHATBOT_STATUSES.READY]: 'Ready',
  [CHATBOT_STATUSES.ERROR]: 'Uh Oh! Something went wrong'
};

export const CHATBOT_MESSAGE_STATUSES = {
  IN_PROGRESS: 'In Progress',
  ERROR: 'Error',
  DONE: 'Done'
};
